package viewer

import editor.SelectionManager
import editor.structure.Structure
import editor.structure.StructureElement
import ext.changeMaterialColor
import ext.changeMaterialTransparency
import raycasting.RaycastingManager
import three.js.Group

object ViewerSelection {
    fun handleSelection(objects: Group, structure: Structure): StructureElement? {
        val intersection = RaycastingManager.getFirstIntersection(objects.children)
        val selected = SelectionManager.maybeSelect(objects.children, intersection)?.parent
        val selectedElt = selected?.let {
            structure.firstOrNull { it.object3D.uuid == selected.uuid }
        }

        // actually apply transparency
        if (selectedElt !== null) {
            setTransparency(objects, 0.3)
            selectedElt.object3D.children.firstOrNull()?.changeMaterialTransparency(1.0)
            selectedElt.object3D.children.firstOrNull()?.changeMaterialColor(0xfafa00)
        } else {
            setTransparency(objects, 1.0)
        }

        return selectedElt
    }

    fun setTransparency(objects: Group, value: Double) {
        objects.children.forEach { obj ->
            obj.children.forEach { inner ->
                inner.changeMaterialTransparency(value)
                inner.changeMaterialColor(0xffffff)
            }
        }
    }
}